import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const SiteLayout = () => (
  <div className="min-h-screen bg-midnight text-white">
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default SiteLayout;
